import {useCallback, useEffect, useState} from 'react'
import jwtDecode from 'jwt-decode'
import {io} from 'socket.io-client'
import SocketStore from "../stores/socket.store";


const storageName = 'userData'


const callServerThatImOnline = (host, userId) => {
    const def = io(host, {path: '/socket'})
    let socket = def.connect()
    let id = socket.id

    socket.emit('imOnline', {
        connectionId: id,
        userId
    })

    socket.emit('getUserStatus', 'userId')
    socket.on('getUserStatus', (data) => {
    })

    socket.on('', (data) => {
    })

}

export const useAuth = () => {
    const [token, setToken] = useState(null)
    const [ready, setReady] = useState(false)
    const [userId, setUserId] = useState(null)
    const [roleId, setRoleId] = useState(null)

    const userName = token && jwtDecode(token.token).name
    /**
     * @function login
     * Заносит параметры в localstorage и производит подключение к сокет-серверу. Используется для авторизации пользователя.
     * @param {string} token
     * @param {string} id
     * */
    const login = useCallback((jwtToken, id) => {
        const roleId = jwtDecode(jwtToken.token).role
        const userId = jwtDecode(jwtToken.token).id
        SocketStore.connect()
        localStorage.setItem(storageName, JSON.stringify({
            token: jwtToken,
            userId: userId
        }))
        SocketStore.addListeners(socket => {
            socket.emit('imOnline', {userId: userId, token: jwtToken.token})
            socket.emit('join', userId)

        })

        setToken(jwtToken)
        setUserId(userId)
        setRoleId(roleId)

    }, [])
    /**
     * @function logout
     * Удаляет токен из localstorage.
     * Использует для выхода.
     * */
    const logout = useCallback(() => {
        setToken(null)
        setUserId(null)
        localStorage.removeItem(storageName)
    }, [])

    /**
     * Проверка на наличие токена в localstorage.
     * При наличии токена, происходит авторизация через функцию login
     * */
    useEffect(() => {
        const data = JSON.parse(localStorage.getItem(storageName))
        if (data && data.token) {
            login(data.token)
            callServerThatImOnline(process.env.REACT_APP_SOCKET_HOST, data?.token?.userId)
        }
        setReady(true)
    }, [login])

    return {login, userName, logout, token, userId, ready, roleId}
}
